import { Box } from '@wix/design-system';
import React from 'react';
import { useValidChildren } from '../../hooks/useValidChildren';
import ProductCard from './ProductCard/ProductCard';
const modifyCardsUi = (validCards, gap) => {
    return validCards.reduce((modified, card, idx, allCards) => {
        const currCard = card;
        if (currCard.props.shadow && !gap) {
            if (idx > 0) {
                const prevCard = React.cloneElement(allCards[idx - 1], {
                    borderRight: 'none',
                    key: idx - 1,
                });
                modified[idx - 1] = prevCard;
            }
            if (idx < allCards.length - 1) {
                const nextCard = React.cloneElement(allCards[idx + 1], {
                    borderLeft: 'none',
                    key: idx + 1,
                });
                modified[idx + 1] = nextCard;
            }
        }
        return modified;
    }, validCards);
};
const ProductCardList = ({ children, gap }) => {
    const validCards = useValidChildren(children, [ProductCard], () => `ProductCardList only accepts ProductCardList.Card as children. Got invalid child:`);
    const modifiedCards = modifyCardsUi(validCards, gap);
    return (React.createElement(Box, { direction: "horizontal", gap: gap && `${gap}px`, verticalAlign: "bottom", align: "center" }, modifiedCards));
};
ProductCardList.Card = ProductCard;
export default ProductCardList;
//# sourceMappingURL=ProductCardList.js.map